import { actionTypes } from './constants';
import { fromJS } from 'immutable';

const defaultReferralSectionState = fromJS({
  referredBy: null,
  referrals: [],
});

const initState = fromJS({
  referralsData: defaultReferralSectionState,
  referralsLoading: false,
});

const referralsReducer = (state = initState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_MEMBER_REFERRALS_SUCCESS:
      return state.set('referralsData', fromJS(action.payload));
    case actionTypes.FETCH_MEMBER_REFERRALS_LOADING:
      return state.set('referralsLoading', action.payload);
    case actionTypes.RESET_MEMBER_REFERRALS:
      return state.set('referralsData', defaultReferralSectionState);
    case actionTypes.ADD_MEMBER_REFERRAL_LOADING:
      return state.set('createReferralLoading', action.payload);
    case actionTypes.ADD_MEMBER_REFERRAL:
      return state.set('createReferralResult', action.payload);
    case actionTypes.SET_REFERRED_BY_LOADING:
      return state.set('referredByLoading', action.payload);
    case actionTypes.SET_REFERRED_BY:
      return state.set('referredByResult', action.payload);
    default:
      return state;
  }
};

export default referralsReducer;
